import Button from "antd/lib/button";
import Popover from "antd/lib/popover";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { useCallback, useState } from "react";
import { Modal } from "antd";

const DeleteAction = ({
    disabled,
    handleDelete,
    name,
    description,
    type,
}: {
    disabled: boolean;
    handleDelete: () => void;
    name: string;
    description: string;
    type: "wallet" | "exchange" | "contact";
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onOk = useCallback(() => {
        handleDelete();
        setIsModalOpen(false);
    }, [handleDelete]);

    return (
        <>
            <Popover
                content={
                    disabled
                        ? `Cannot delete ${type} during processing`
                        : `Delete ${type}`
                }
            >
                <Button
                    type="text"
                    onClick={() => {
                        setIsModalOpen(true);
                    }}
                    className="group"
                    disabled={disabled}
                    icon={<DeleteRoundedIcon />}
                />
            </Popover>
            <Modal
                width={660}
                title={
                    <div className="mb-8 text-2xl">
                        {`Are you sure you want to delete ${name}`}
                    </div>
                }
                open={isModalOpen}
                onOk={onOk}
                onCancel={() => {
                    setIsModalOpen(false);
                }}
                footer={
                    <div className="flex justify-between">
                        <Button
                            key="cancel"
                            type="text"
                            size="large"
                            onClick={() => {
                                setIsModalOpen(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            key="submit"
                            type="primary"
                            size="large"
                            className="h-[50px] bg-accounting-red px-12"
                            onClick={onOk}
                        >
                            Yes, delete
                        </Button>
                    </div>
                }
                styles={{
                    content: {
                        padding: "40px",
                    },
                }}
            >
                <div className="mb-10 text-base">{description}</div>
            </Modal>
        </>
    );
};

export default DeleteAction;
